<template>
  <div class="container mx-auto lg:py-16 py-10 px-3 flex lg:flex-row flex-col gap-8">
    <div class="lg:w-1/2 h-auto relative">
      <img src="../../assets//v-1.1//ourservice.png" class="w-full lg:h-full h-[350px]" />
      <div class="absolute bottom-0 left-0 w-full lg:w-[40%] lg:h-[35%] p-2 text-white bg-primary flex flex-col gap-2">
        <div class="bg-primary flex justify-center items-center rounded-sm">
          <img src="../../assets/v-1.1/user_icon.svg" class="w-[80px] h-[80px]" width="80px" />
        </div>
        <div class="font-semibold text-base text-center">We Provide Best Quality Services 24X7</div>
        <div class="lg:text-md text-center text-sm ">We understand that plumbing and heating emergencies can occur at any
          time.</div>
      </div>
    </div>
    <div class="flex flex-col justify-start lg:w-1/2 lg:gap-5 gap-2">
      <div class="text-lg font-semibold text-primary">
        About Services
      </div>
      <h2 class="lg:text-4xl text-2xl font-bold font-primary">
        Experienced Professionals Deliver Commercial and Residential Plumbing Services
      </h2>
      <div class="text-base text-grey">
        When it comes to professional plumbing and heating services, our team is here to meet your needs with expertise and efficiency. A Customized Approach for Your Home We understand that every home is unique, and that's why we take a customized approach to each project. We value your time and understand that plumbing and heating issues can cause inconvenience. Experienced Professionals at Your Service Our team consists of experienced professionals who bring a wealth of knowledge and expertise to every project. Trust us and hire us for plumbing and heating services. When you choose our services, you can trust that you're getting the best in the industry.
      </div>
      <div class="">
        <div class="grid grid-cols-12 rounded-sm my-4">
          <div class="col-span-2 bg-primary flex justify-center items-center p-3 rounded-sm ">
            <img src="../../assets/v-1.1/make-appointment-white.svg" height="80px" class="object-fill" />
          </div>
          <div class="col-span-10 p-2">
            <div class="font-semibold font-primary">The Best Quality Service </div>
            <div class="text-grey">Our service provides many factors, including timely response times.
            </div>
          </div>
        </div>
        <div class="grid grid-cols-12 rounded-sm my-4">
          <div class="col-span-2 bg-primary flex justify-center items-center p-3 rounded-sm ">
            <img src="../../assets/v-1.1/solve-problem-white.svg" class="object-fill" height="80px" />
          </div>
          <div class="col-span-10 p-2">
            <div class="font-semibold font-primary">Experienced Professionals </div>
            <div class="text-grey">Hire our expert team of highly certified master and licensed plumbers for exceptional quality in plumbing services.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>